import { ContentTabs, Horizontal, MaterialIcon } from '@gravitate-js/excalibrr'
import type { DeliveryReconOverviewResponse, DeliveryReconTab } from '../types'

type StatusTabsProps = {
  onChange: (tab: DeliveryReconTab, setting: 'default' | 'extended') => void
  isExtended: boolean
  tab: DeliveryReconTab
  data: DeliveryReconOverviewResponse | undefined
}

export function StatusTabs({ onChange, isExtended, tab, data }: StatusTabsProps) {
  return (
    <Horizontal className='pl-4 delivery-rec-content-tabs' width='100%' justifyContent='space-between'>
      <ContentTabs
        className='extended-tabs'
        activeKey={tab}
        onChange={(tab) => onChange(tab as DeliveryReconTab, 'extended')}
        items={[
          {
            title: 'Open',
            key: 'open',
            icon: <MaterialIcon className='pr-1' icon='pending' size={16} />,
            count: isExtended
              ? data?.rows?.filter((d) => d.status === 'matched' || d.status === 'unmatched')?.length
              : undefined,
          },
          {
            title: 'Unmatched',
            key: 'unmatched',
            icon: <MaterialIcon className='pr-1' icon='link_off' size={16} />,
            count: isExtended ? data?.rows?.filter((d) => d.status === 'unmatched')?.length : undefined,
            color: 'error',
          },
          {
            title: 'Matched',
            key: 'matched',
            icon: <MaterialIcon className='pr-1' size={16} icon='link' />,
            count: isExtended ? data?.rows?.filter((d) => d.status === 'matched')?.length : undefined,
            color: 'warning',
          },
        ]}
      />
      <ContentTabs
        activeKey={tab}
        onChange={(tab) => onChange(tab as DeliveryReconTab, 'default')}
        items={[
          {
            title: 'All',
            icon: <MaterialIcon className='pr-1' size={16} icon='list' />,
            key: '',
          },
          {
            title: 'Approved',
            icon: <MaterialIcon className='pr-1' size={16} icon='check_circle' />,
            key: 'approved',
            color: 'success',
          },
          {
            title: 'Voided',
            key: 'voided',
            icon: <MaterialIcon className='pr-1' size={16} icon='cancel' />,
          },
        ]}
      />
    </Horizontal>
  )
}
